export default "__VITE_ASSET__DEuK5Gfo__"